import { render, staticRenderFns } from "./UserGroupAdd.vue?vue&type=template&id=6fb4e113&scoped=true&"
import script from "./UserGroupAdd.vue?vue&type=script&lang=js&"
export * from "./UserGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupAdd.vue?vue&type=style&index=0&id=6fb4e113&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4e113",
  null
  
)

export default component.exports